export type AnimationStyleParams = {
  display: string;
  slideFrom?: 'top' | 'bottom';
  forceTransformIn?: string;
  forceTransformOut?: string;
};

/**
 * Build animation transform styles for popover content.
 * Handles slide-in/slide-out animations based on the slideFrom direction.
 */
export function buildAnimationStyles({
  display,
  slideFrom,
  forceTransformIn,
  forceTransformOut,
}: AnimationStyleParams): { transform: string } {
  const transform =
    display === 'block'
      ? forceTransformIn || `translateY(0)`
      : forceTransformOut || `translateY(${slideFrom === 'top' ? '10px' : '-10px'})`;

  return { transform };
}
